import { useEffect, useState } from "react";
import api from "@/lib/api";

// Simple in-module cache + subscribers so that a single fetch is shared across components
let cached = null;
let inFlight = null;
const listeners = new Set();

function notify(next) {
  cached = next;
  listeners.forEach((cb) => cb(next));
}

export function refreshSettings() {
  inFlight = api.get("/settings").then((r) => {
    notify(r.data || {});
    return r.data;
  }).catch(() => {
    notify({});
    return {};
  }).finally(() => { inFlight = null; });
  return inFlight;
}

export default function useSettings() {
  const [data, setData] = useState(cached || {});
  useEffect(() => {
    listeners.add(setData);
    if (cached == null && !inFlight) refreshSettings();
    return () => { listeners.delete(setData); };
  }, []);
  return data;
}
